export const NO_FUNDS_STATE = 'no_funds'
export const REVIEW_STATE = 'review'
export const VERTICAL_BLOCKED_STATES = ['approved', 'paused', 'completed']
export const PA4KA_DOMAIN = 'p.pa6ka.com'

export const ONBOARDING_STEPS = [
  {
    href: '/campaigns/new',
    title: 'Create campaign',
    description: 'Find the traffic you need.',
    allowed_routes: ['^/campaigns/new'],
    success_message: 'To continue onboarding create a creative'
  },
  {
    href: '/campaigns?puls',
    title: 'Add creatives',
    description: 'Upload your creatives.',
    allowed_routes: [
      '^/campaigns$',
      '^/campaigns\\?puls$',
      '^/campaigns/\\d+$',
      '^/campaigns/edit/\\d+$',
      '^/campaigns/clone/\\d+$',
      '^/campaigns/\\d+/creatives/new$'
    ],
    success_message: 'To continue onboarding fill the profile'
  },
  {
    href: '/profile',
    title: 'Complete profile',
    description: 'Required for billing and payouts (2-3 minutes).',
    allowed_routes: ['^/profile.*'],
    success_message: 'Top up your balance and finish onboarding'
  },
  {
    href: '/payment',
    title: 'Top up & launch',
    description: 'Start with $10 and scale fast.',
    allowed_routes: ['^/payment.*']
  }
]

export const ONBOARDING_ALLOWED_ROUTES = ONBOARDING_STEPS.map(
  (step) => step.allowed_routes
)

export const AUTH_ROUTES = [
  '/login',
  '/registration',
  '/restore',
  '/confirmation',
  '/reset_password',
  '/bcm'
]
